@if (isFromCustomers()) {
<app-header>
  <app-orders-header></app-orders-header>
</app-header>
}
<div class="orders-home tick-page-container mb-4">
  @if (isFromCustomers()) {
  <app-orders-list-filters></app-orders-list-filters>
  }
  <app-orders-tree-list></app-orders-tree-list>
</div>
